export class ResetPasswordRequest{
    token: string;
    password: string;
    confirmPassword: string;
}
